/* unplugin-vue-components disabled */import { render } from "./ComicsItemDetails.vue?vue&type=template&id=1b370f1f&scoped=true"
import script from "./ComicsItemDetails.vue?vue&type=script&lang=js"
export * from "./ComicsItemDetails.vue?vue&type=script&lang=js"

import "./ComicsItemDetails.vue?vue&type=style&index=0&id=1b370f1f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b370f1f"]])

export default __exports__